import { currentBrand } from '@common/brand/brandConfig';

const FAVICON_SIZES = [16, 32, 128, 152, 167, 180, 192] as const;

const publicPath = process.env.PUBLIC_PATH ?? '/';

FAVICON_SIZES.forEach((size) => {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = `${publicPath}assets/favicons/${currentBrand}/favicon-${size}.png`;
  document.head.appendChild(link);
});
